module.exports = __webpack_public_path__ + "static/img/cross.260c9c65.png";